// This file is autogenerated. Any changes will be overwritten.

import useUID from '../../../hooks/useUID';

export const set = 'streamline';

export const name = 'disc-stack-solid';

export const Component = () => {
  const maskId = useUID();

  return (
    <>
      <defs>
        <mask id={maskId} fill='#000' stroke='#000' strokeLinecap='round'>
          <path fill='#fff' stroke='#fff' d='M0 0h18v18H0z' />
          <path
            fill='#fff'
            d='M.5 9c0 2.07 4.303 3.75 8.5 3.75s8.5-1.678 8.5-3.75M.5 4C.5 6.07 4.803 7.75 9 7.75S17.5 6.072 17.5 4'
          />
        </mask>
      </defs>
      <path
        fill='currentColor'
        stroke='currentColor'
        d='M9 1.5c-1.915 0-3.772.303-5.162.86-.695.278-1.267.616-1.67 1.006-.406.392-.668.862-.668 1.386a1.546 1.546 0 0 0 0 .052v8.444c0 .544.277 1.02.688 1.407.41.388.98.717 1.65.985 1.342.537 3.167.86 5.162.86s3.82-.323 5.162-.86c.67-.268 1.24-.597 1.65-.985.41-.388.688-.863.688-1.407V4.752c0-.524-.262-.994-.667-1.386-.404-.39-.976-.728-1.67-1.006-1.39-.557-3.248-.86-5.163-.86z'
        mask={`url(#${maskId})`}
      />
    </>
  );
};

export const viewBox = '0 0 18 18';
